module.exports = __webpack_public_path__ + "img/cross.86df285c.svg";